import React, { useEffect, useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

import collections from "../../assets/deals.jpg";
import collections_1 from "../../assets/collections-1.jpg";
// import collections_2 from "../../assets/clinique.jpg";
import collections_3 from "../../assets/adrienne.jpg";
import { gsap } from "gsap";
// Import modules from "swiper/modules"
import { Autoplay, Pagination, Navigation } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { useNavigate } from "react-router-dom";
import { Buttons } from "../Buttons";
import { FaArrowRightLong } from "react-icons/fa6";

const Explore = () => {
  const navigate = useNavigate();
  const bannerImages = [
    collections,
    collections_1,
    // collections_2,
    collections_3,
  ];
  const containerRef = useRef(null);
  const headingRef = useRef(null);
  const paragraphRef = useRef(null);
  const buttonRef = useRef(null);
  const overlayRef = useRef(null);
  const imageRef = useRef(null);
  const [currentImage, setCurrentImage] = useState(0);
  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: containerRef.current,
        start: "top 80%",
        toggleActions: "play reverse play reverse",
      },
    });

    // Background image fade & scale
    tl.fromTo(
      imageRef.current,
      { scale: 1.1, opacity: 0 },
      { scale: 1, opacity: 1, duration: 1.2, ease: "power3.out" },
    );

    // Overlay fade in
    tl.fromTo(
      overlayRef.current,
      { opacity: 0 },
      { opacity: 0.7, duration: 1, ease: "power3.out" },
      "<",
    );

    // Heading
    tl.fromTo(
      headingRef.current,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1, ease: "power3.out" },
    );

    // Paragraph
    tl.fromTo(
      paragraphRef.current,
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 1, ease: "power3.out" },
      "<0.3",
    );

    // Button
    tl.fromTo(
      buttonRef.current,
      { opacity: 0, y: 20, scale: 0.95 },
      { opacity: 1, y: 0, scale: 1, duration: 0.8, ease: "power3.out" },
      "<0.2",
    );

    return () => tl.kill();
  }, []);
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentImage((prev) => (prev + 1) % images.length); // loop through images
  //   }, 5000); // every 8 seconds

  //   return () => clearInterval(interval);
  // }, []);
  return (
    <div className="w-full">
      <Swiper
        modules={[Autoplay, Pagination, Navigation]}
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        autoplay={{ delay: 2500, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        className="w-full"
      >
        {bannerImages.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="w-full h-[60vh] flex justify-center items-center relative cursor-pointer">
              {/* Poster Image */}
              <img
                src={slide}
                alt={`banner-${index}`}
                className="w-full h-full object-cover transition-transform duration-500 ease-in-out hover:scale-105"
              />
              {/* Glass/Dark overlay */}
              <div className="absolute inset-0 bg-black  transition-opacity duration-500 bg-opacity-50"></div>
              {/* conente */}
              <div className="absolute inset-0 bg-black bg-opacity-50"></div>

              {/* Content Layer */}
              <div className="absolute inset-y-0 right-0 z-10 flex flex-col justify-center items-center md:items-start px-6 md:px-12 text-center md:text-start w-full md:w-[600px]">
                <h1 className="text-white text-3xl sm:text-4xl md:text-5xl font-bold leading-tight mb-4">
                  Explore The Lattafa Collection
                </h1>
                <p className="text-white text-lg sm:text-xl md:text-2xl font-light mb-6">
                  Save up to 45% through our exclusive sale.
                </p>
                <Buttons
                  title="Shop the Collection"
                  handleClick={() => navigate("/fragrance")}
                  icon={<FaArrowRightLong />}
                />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Explore;

// import React, { useRef, useEffect, useState } from "react";
// import collections from "../../assets/collections.png";
// import collections_1 from "../../assets/collections-1.jpg";
// import collections_2 from "../../assets/collections-3.jpg";
// import collections_3 from "../../assets/contact.png";
// import { FaArrowRightLong } from "react-icons/fa6";
// import { Buttons } from "../Buttons";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { useNavigate } from "react-router-dom";

// gsap.registerPlugin(ScrollTrigger);

// const images = [collections, collections_1, collections_2, collections_3];

// const Explore = () => {
//   const containerRef = useRef(null);
//   const headingRef = useRef(null);
//   const paragraphRef = useRef(null);
//   const buttonRef = useRef(null);
//   const overlayRef = useRef(null);
//   const imageRef = useRef(null);
//   const navigate = useNavigate();
//   const [currentImage, setCurrentImage] = useState(0);
//   useEffect(() => {
//     const tl = gsap.timeline({
//       scrollTrigger: {
//         trigger: containerRef.current,
//         start: "top 80%",
//         toggleActions: "play reverse play reverse",
//       },
//     });

//     // Background image fade & scale
//     tl.fromTo(
//       imageRef.current,
//       { scale: 1.1, opacity: 0 },
//       { scale: 1, opacity: 1, duration: 1.2, ease: "power3.out" },
//     );

//     // Overlay fade in
//     tl.fromTo(
//       overlayRef.current,
//       { opacity: 0 },
//       { opacity: 0.7, duration: 1, ease: "power3.out" },
//       "<",
//     );

//     // Heading
//     tl.fromTo(
//       headingRef.current,
//       { opacity: 0, y: 50 },
//       { opacity: 1, y: 0, duration: 1, ease: "power3.out" },
//     );

//     // Paragraph
//     tl.fromTo(
//       paragraphRef.current,
//       { opacity: 0, y: 30 },
//       { opacity: 1, y: 0, duration: 1, ease: "power3.out" },
//       "<0.3",
//     );

//     // Button
//     tl.fromTo(
//       buttonRef.current,
//       { opacity: 0, y: 20, scale: 0.95 },
//       { opacity: 1, y: 0, scale: 1, duration: 0.8, ease: "power3.out" },
//       "<0.2",
//     );

//     return () => tl.kill();
//   }, []);
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentImage((prev) => (prev + 1) % images.length); // loop through images
//     }, 5000); // every 8 seconds

//     return () => clearInterval(interval);
//   }, []);
//   return (
//     <div
//       ref={containerRef}
//       className="relative bg-black px-4 sm:px-6 lg:px-20 py-[2rem] md:py-[8rem] overflow-x-hidden" // prevent horizontal scroll
//     >
//       <div className="relative w-full flex justify-center py-[14rem] items-center ">
//         {/* Background Image */}
//         <div
//           ref={imageRef}
//           className="absolute inset-0 bg-cover bg-center rounded-lg"
//           style={{ backgroundImage: `url(${images[currentImage]})` }}
//         />

//         {/* Semi-transparent Overlay */}
//         <div
//           ref={overlayRef}
//           className="absolute inset-0 bg-black/70 rounded-lg"
//         />

//         {/* Content Layer */}
//         <div className="relative z-10 flex flex-col md:flex-row w-full max-w-full items-center gap-6 md:gap-10 px-4">
//           {/* Left Spacer */}
//           <div className="flex-1 min-w-0" />{" "}
//           {/* min-w-0 ensures flex child doesn’t overflow */}
//           {/* Right Text */}
//           <div className="flex-1  max-w-lg flex flex-col justify-center items-start gap-6 md:text-left min-w-0">
//             <h1
//               ref={headingRef}
//               className="text-white text-3xl sm:text-4xl md:text-5xl font-bold leading-tight break-words"
//             >
//               Explore The Lattafa Collection
//             </h1>
//             <p
//               ref={paragraphRef}
//               className="text-white text-lg sm:text-xl md:text-2xl font-light break-words"
//             >
//               Save up to 45% through our exclusive sale.
//             </p>
//             <div ref={buttonRef} className="flex-shrink-0">
//               <Buttons
//                 title="Shop the Collection"
//                 handleClick={() => navigate("/fragrance")}
//                 icon={<FaArrowRightLong />}
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Explore;
